import { render } from "./RankListSkeleton.vue?vue&type=template&id=3e9b83e6&scoped=true"
import script from "./RankListSkeleton.vue?vue&type=script&lang=js"
export * from "./RankListSkeleton.vue?vue&type=script&lang=js"

import "./RankListSkeleton.vue?vue&type=style&index=0&id=3e9b83e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9b83e6"]])

export default __exports__